// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1fbkZ","header":"PatientBlock_header__LvenK","label":"PatientBlock_label__1Chp2","option":"PatientBlock_option__2SPIi"};